import { render, staticRenderFns } from "./Followup.vue?vue&type=template&id=7aa1e725&scoped=true"
import script from "./Followup.vue?vue&type=script&lang=js"
export * from "./Followup.vue?vue&type=script&lang=js"
import style0 from "./Followup.vue?vue&type=style&index=0&id=7aa1e725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa1e725",
  null
  
)

export default component.exports